export const PortalHomeTxt={
    "support":"We always try and be there for you, our Vieunite artists when you need us. We are available Monday - Friday 9am-6pm (UK Time)",
    "phone":"+44 (0)3455481311",
    "email":"vieuniteartistsupport@vieunite.com",
}